import React from 'react';
import SensitiveDataComplianceTool from './components/PiiTool';

function App() {
  return <SensitiveDataComplianceTool />;
}

export default App;
